export class ActiveWalletDetail{
    uuid: string;
    quantity: number;
    walletRegistrationType: string;
    unitValue: number;
    campaignId: string;
}